import { styled, Theme } from '@mui/material';
import { CoreDialogContent } from '@youscience/core';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      maxWidth: '600px',
      width: '100%',
      borderRadius: '12px',
    },
  },
  title: {
    marginBottom: '1.5rem',
  },
  description: {
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
  footer: (theme: Theme) => ({
    padding: '1.5rem',
    borderTop: `1px solid ${theme.palette.grey['300']}`,
  }),
  checkBoxTitle: {
    marginTop: '0.563rem',
  },
  checkBox: {
    display: 'flex',
    alignItems: 'start',
    marginTop: '1.5rem',
  },
};

export const StyledDialogContent = styled(CoreDialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  padding: '2.5rem 1.5rem',
  maxWidth: '600px',
  minHeight: '320px',

  [theme.breakpoints.up('xs')]: {
    minHeight: '384px',
  },
}));
